export const TESTING_SHOP = [
  'quangdn.myshopify.com',
  'hieu-test-app-1.myshopify.com',
  'phuonganh-po-teststore.myshopify.com',
  'estimated-develop-store.myshopify.com',
  'bui-dinh-du-2.myshopify.com',
  'oanhlt-teststore-1.myshopify.com',
  'aylin-plus.myshopify.com',
];
